import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-commentInput-control-value-view, [app-commentInput-control-value-view]',
  templateUrl: './commentInput-control-value-view.component.html',
  styleUrls: ['./commentInput-control-value-view.component.scss']
})
export class CommentInputControlValueViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
